import { REHYDRATE } from "redux-persist";
import { getBetTable } from "../common/Funcation";
import Cookies from "universal-cookie";
const cookies = new Cookies();

function usableHomeData(data) {
  return !!(
    data &&
    typeof data === "object" &&
    !Array.isArray(data) &&
    (Array.isArray(data.dashboardImagesInfo) || Array.isArray(data.bannersInfo))
  );
}

let initState = {
  test: "",
  userData: {},
  isAuthenticated: false,
  Header: {},
  balance: "",
  remaining_balance: "",
  webEdit: {},
  matchCount: {},
  getSport: {},
  sportDetails: {},
  betHistory: {},
  exposure: "",
  calcOntime: false,
  calcData: {},
  scoreCard: [],
  marketListDetails: {},
  cricket: {},
  soccer: {},
  tennis: {},
  betHistoryShow: false,
  homeData: {},
};

function skyReducer(state = initState, action) {
  switch (action.type) {
    case "AUTHENTICATION": {
      return { ...state, isAuthenticated: action.payload };
    }
    case "SHOW_BET_HISTORY": {
      return { ...state, betHistoryShow: !state.betHistoryShow };
    }
    case "SET_BET_HISTORY_SHOW": {
      return { ...state, betHistoryShow: !!action.payload };
    }
    case "USER_DATA": {
      return { ...state, userData: action.payload };
    }
    case "HEADER_DETAILS": {
      return {
        ...state,
        Header: action.payload,
        balance: action.payload.balance,
        remaining_balance:
          action.payload.remaining_balance !== undefined &&
          action.payload.remaining_balance !== null
            ? action.payload.remaining_balance
            : action.payload.balance,
        exposure: action.payload.exposure,
      };
    }
    case "DOMAIN_DETAILS": {
      return { ...state, domainDetails: action.payload };
    }
    case "MARKET_LIST_DETAILS": {
      return { ...state, marketListDetails: action.payload };
    }
    case "EDIT_WEBSITE": {
      return { ...state, webEdit: action.payload };
    }
    case "UPDATE_USER_BALANCE": {
      return {
        ...state,
        balance:
          action.payload?.balance !== undefined && action.payload?.balance !== null
            ? action.payload.balance
            : state.balance,
        remaining_balance:
          action.payload?.remaining_balance !== undefined &&
          action.payload?.remaining_balance !== null
            ? action.payload.remaining_balance
            : state.remaining_balance,
        exposure:
          action.payload?.exposure !== undefined && action.payload?.exposure !== null
            ? action.payload.exposure
            : state.exposure,
      };
    }
    case "SET_HOME_DATA": {
      return {
        ...state,
        homeData: action.payload,
      };
    }
    case "SET_IN_PLAY_DETAILS": {
      return {
        ...state,
        inPlayDetail: {
          inPlay: undefined,
          today: undefined,
          tomorrow: undefined,
        },
      };
    }
    case "SET_IN_PLAY_DETAILS_IN_PLAY": {
      return {
        ...state,
        inPlayDetail: { ...state.inPlayDetail, inPlay: action.payload },
      };
    }
    case "SET_IN_PLAY_DETAILS_TODAY": {
      return {
        ...state,
        inPlayDetail: { ...state.inPlayDetail, today: action.payload },
      };
    }
    case "SET_IN_PLAY_DETAILS_TOMORROW": {
      return {
        ...state,
        inPlayDetail: { ...state.inPlayDetail, tomorrow: action.payload },
      };
    }
    case "GET_SCORE_ID": {
      return {
        ...state,
        scoreCard: action.payload,
      };
    }
    case "GET_SPORTS_DETAILS": {
      let sportCopy = action.payload ? { ...action.payload } : {};
      state.sportDetails = action.payload;
      if (
        cookies.get("skyTokenFront") &&
        JSON.stringify(state?.betHistory) !== "{}" &&
        JSON.stringify(action.payload) !== "{}"
      ) {
        // console.log('GET_SPORTS_DETAILS', action.payload);
        console.log(
          ":::::::::::betsHistory",
          JSON.stringify(state?.betHistory) !== "{}"
        );

        // for odds
        let tableCopyActiveId = sportCopy.matchInfo?._id;
        let filteredHIstory = state?.betHistory?.filter(
          (_) => _.matchId._id === tableCopyActiveId
        );
        const OddsTable = state.calcOntime
          ? state.calcData
          : state?.betHistory?.find(
              (_) => _.betType === "odds" && _.matchId._id === tableCopyActiveId
            );
        const profitsOdds = state.calcOntime
          ? filterSportCount(
              filteredHIstory,
              "odds",
              state.calcOntime,
              state.calcData
            )
          : filterSportCount(filteredHIstory, "odds");
        let tableCopy = sportCopy.page?.data[getBetTable("odds")];
        if (OddsTable && OddsTable.winnerSelection) {
          tableCopy.forEach(
            (subElement) => (subElement.betProfit = profitsOdds[subElement.nat])
          );
        }
        sportCopy.page.data[getBetTable("odds")] = tableCopy;

        // for book maker

        let filteredBookHIstory = state?.betHistory?.filter(
          (_) => _.matchId._id === tableCopyActiveId
        );

        const BookMarkTable = state.calcOntime
          ? state.calcData
          : state?.betHistory?.find((_) => _.betType === "bookMark");
        const profitsBookMark = state.calcOntime
          ? filterSportCount(
              filteredBookHIstory,
              "bookMark",
              state.calcOntime,
              state.calcData
            )
          : filterSportCount(filteredBookHIstory, "bookMark");
        let tableCopyBookMark = sportCopy.page?.data[getBetTable("bookMark")];
        if (BookMarkTable) {
          tableCopyBookMark.forEach(
            (subElement) =>
              (subElement.betProfit = profitsBookMark[subElement.nat])
          );
        }

        sportCopy.page.data[getBetTable("bookMark")] = tableCopyBookMark;
        // FOR PRI

        let filteredpremiumHIstory = state?.betHistory?.filter(
          (_) => _.matchId._id === tableCopyActiveId
        );

        const PreTable = state.calcOntime
          ? state.calcData
          : state?.betHistory?.find((_) => _.betType === "premium");
        const profitsPreMark = state.calcOntime
          ? filterSportPreCount(
              filteredpremiumHIstory,
              "premium",
              state.calcOntime,
              state.calcData
            )
          : filterSportPreCount(filteredpremiumHIstory, "premium");
        let tableCopyPre = sportCopy.pre?.data?.t4;
        console.log("::::::::", tableCopyPre);
        console.log(":::::::: profitsPreMark : ", profitsPreMark);
        if (PreTable) {
          tableCopyPre.forEach((subElement) => {
            subElement?.sub_sb.forEach(
              (x) =>
                (x.betProfit = profitsPreMark[subElement?.marketName]
                  ? profitsPreMark[subElement?.marketName][x.nat]
                  : undefined)
            );
          });
        }
        sportCopy.page.data[getBetTable("premium")] = tableCopyPre;

        //for fancy
        // const fancyTable = state?.betHistory?.betsHistory.find(_ => _.betType === "bookMark")
        if (state?.betHistory) {
          // const profitsfancy = betsLastExposure(state?.betHistory)
          const profitsfancy = bookExposer(state?.betHistory);
          // console.log(':::::::::::::bookExposer up', profitsfancyexpo);
          let tableCopyfancy = sportCopy.page?.data[getBetTable("session")];
          if (profitsfancy.length && Array.isArray(tableCopyfancy)) {
            tableCopyfancy.forEach((subElement) => {
              let findele = profitsfancy.findIndex(
                (_) => _.selection === subElement.nat
              );
              console.log(":::::::::findele");
              if (findele !== -1) {
                subElement.betProfit =
                  profitsfancy[findele].exposure.toFixed(2);
              }
            });
          }
          sportCopy.page.data[getBetTable("session")] = tableCopyfancy;
          const tableCopyUnder = sportCopy.page?.data?.t5;
          if (Array.isArray(tableCopyUnder) && profitsfancy.length) {
            tableCopyUnder.forEach((subElement) => {
              const title = subElement.mname || subElement.nat;
              const found = profitsfancy.find((row) => row.selection === title);
              if (found) subElement.betProfit = found.exposure.toFixed(2);
            });
            sportCopy.page.data.t5 = tableCopyUnder;
          }
        }
      }

      return { ...state, sportDetails: sportCopy };
    }
    case "GET_LIVE_MATCH_COUNT": {
      return { ...state, matchCount: action.payload };
    }
    case "GET_SPORTS": {
      return {
        ...state,
        getSport: action.payload,
        [action.payload.type]: action.payload,
      };
    }
    case "GET_SPORTS_LIVE_CALC": {
      return { ...state, ...action.payload };
    }
    case "LIVE_TV": {
      return { ...state, myTv: action.payload };
    }
    case "USER_BET_HISTORY": {
      let sportCopy = state.sportDetails;
      // state.betHistory = action.payload
      console.log("GET_SPORTS_DETAILS", state.sportDetails);
      // console.log(':::::::betsHistory',filterSportCount(action.payload.betsHistory), action.payload.betsHistory )

      // const OddsTable = action?.payload?.betsHistory.find(_ => _.betType === "odds")
      // const profitsOdds = filterSportCount(action?.payload?.betsHistory, 'odds')
      // let tableCopy = sportCopy.page?.data[getBetTable('odds')]
      // if (OddsTable) {
      //     tableCopy.forEach(subElement => {
      //         if (subElement.nat === OddsTable.winnerSelection[0]) {
      //             subElement.betProfit = profitsOdds.left
      //         } else if (subElement.nat === OddsTable.winnerSelection[1]) {
      //             subElement.betProfit = profitsOdds.right
      //         } else if (subElement.nat === OddsTable.winnerSelection[2]) {
      //             subElement.betProfit = profitsOdds.draw
      //         }
      //     });
      // }
      // sportCopy.page.data[getBetTable('odds')] = tableCopy

      // // for book maker
      // const BookMarkTable = action?.payload?.betsHistory.find(_ => _.betType === "bookMark")
      // const profitsBookMark = filterSportCount(action?.payload?.betsHistory, 'bookMark')
      // let tableCopyBookMark = sportCopy.page?.data[getBetTable('bookMark')]
      // if (BookMarkTable) {
      //     tableCopyBookMark.forEach(subElement => {
      //         if (subElement.nat === BookMarkTable.winnerSelection[0]) {
      //             subElement.betProfit = profitsBookMark.left
      //         } else if (subElement.nat === BookMarkTable.winnerSelection[1]) {
      //             subElement.betProfit = profitsBookMark.right
      //         } else if (subElement.nat === BookMarkTable.winnerSelection[2]) {
      //             subElement.betProfit = profitsBookMark.draw
      //         }
      //     });
      // }

      // sportCopy.page.data[getBetTable('bookMark')] = tableCopyBookMark

      // //for fancy
      // // const fancyTable = state?.betHistory?.betsHistory.find(_ => _.betType === "bookMark")
      // const profitsfancy = betsLastExposure(action?.payload?.betsHistory)
      // let tableCopyfancy = sportCopy.page?.data[getBetTable('session')]
      // if (profitsfancy.length) {
      //     tableCopyfancy.forEach(subElement => {
      //         let findele = profitsfancy.findIndex(_ => _.selection === subElement.nat)
      //         console.log(':::::::::findele');
      //         if (findele !== -1) {
      //             subElement.betProfit = profitsfancy[findele].exposure
      //         }
      //     });
      // }

      // sportCopy.page.data[getBetTable('session')] = tableCopyfancy

      // state.sportDetails = sportCopy

      return { ...state, betHistory: action.payload };
    }
    case "MAIN_LOADER": {
      return { ...state, loader: action.payload };
    }
    case "LOGOUT":
      return {
        ...state,
        isAuthenticated: false,
        Header: {},
        userData: {},
        balance: "",
        remaining_balance: "",
        exposure: "",
        betHistory: {},
        betHistoryShow: false,
        sportDetails: {},
        getSport: {},
        calcOntime: false,
        calcData: {},
      };
    case REHYDRATE: {
      // Keep website chrome and the public home payload so the next visit
      // can skip the full-screen loader. Auth, balance, and bets stay with
      // the cookie and the API.
      const incoming = action?.payload || {};
      const persistedSite =
        incoming.domainDetails &&
        typeof incoming.domainDetails === "object" &&
        !Array.isArray(incoming.domainDetails)
          ? incoming.domainDetails
          : state.domainDetails;
      const homeData = usableHomeData(state.homeData)
        ? state.homeData
        : usableHomeData(incoming.homeData)
          ? incoming.homeData
          : null;
      return {
        betHistoryShow: false,
        balance: "",
        scoreCard: [],
        calcOntime: false,
        calcData: {},
        getSport: {},
        cricket: {},
        soccer: {},
        tennis: {},
        sportDetails: {},
        betHistory: {},
        ...(persistedSite && Object.keys(persistedSite).length
          ? { domainDetails: persistedSite }
          : {}),
        ...(homeData ? { homeData } : {}),
      };
    }
    default:
      return { ...state };
  }
}

export const reducer = skyReducer;

export function filterSportCount(betsHistory, betType, calcOntime, calcData) {
  let left = 0;
  let right = 0;
  let draw = 0;
  let oldExp = {};

  if (betsHistory) {
    // for await (const bet of betList)
    betsHistory.forEach((bet) => {
      if (bet.betType === betType) {
        const { winnerSelection } = bet;
        console.log(winnerSelection);
        let profileForBet = 0;
        let exposureForBet = 0;
        if (bet.betSide === "back") {
          profileForBet = bet.profit;
          exposureForBet = bet.exposure;
        } else {
          profileForBet = bet.profit;
          exposureForBet = bet.betPlaced;
        }

        console.log("profileForBet :: ", profileForBet);
        console.log("exposureForBet :: ", exposureForBet);
        winnerSelection.forEach((element) => {
          console.log(element, bet, "beeetttt");
          if (element === bet.selection) {
            if (bet.betSide === "back") {
              if (!oldExp[element]) {
                oldExp[element] = profileForBet;
              } else {
                oldExp[element] += profileForBet;
              }
            } else {
              if (!oldExp[element]) {
                oldExp[element] = -profileForBet;
              } else {
                oldExp[element] -= profileForBet;
              }
            }
          } else {
            if (bet.betSide === "back") {
              if (!oldExp[element]) {
                oldExp[element] = -exposureForBet;
              } else {
                oldExp[element] -= exposureForBet;
              }
            } else {
              if (!oldExp[element]) {
                oldExp[element] = exposureForBet;
              } else {
                oldExp[element] += exposureForBet;
              }
            }
          }
        });
      }
    });
  }
  if (calcOntime && calcData && calcData.betType === betType) {
    const { winnerSelection } = calcData;
    console.log(winnerSelection);
    let profileForBet = 0;
    let exposureForBet = 0;
    if (calcData.betSide === "back") {
      profileForBet = calcData.profit;
      exposureForBet = calcData.exposure;
    } else {
      profileForBet = calcData.profit;
      exposureForBet = calcData.betPlaced;
    }

    console.log("profileForBet :: ", profileForBet);
    console.log("exposureForBet :: ", exposureForBet);
    winnerSelection.forEach((element) => {
      if (element === calcData.selection) {
        if (calcData.betSide === "back") {
          if (!oldExp[element]) {
            oldExp[element] = profileForBet;
          } else {
            oldExp[element] += profileForBet;
          }
        } else {
          if (!oldExp[element]) {
            oldExp[element] = -profileForBet;
          } else {
            oldExp[element] -= profileForBet;
          }
        }
      } else {
        if (calcData.betSide === "back") {
          if (!oldExp[element]) {
            oldExp[element] = -exposureForBet;
          } else {
            oldExp[element] -= exposureForBet;
          }
        } else {
          if (!oldExp[element]) {
            oldExp[element] = exposureForBet;
          } else {
            oldExp[element] += exposureForBet;
          }
        }
      }
    });
  }

  // return { left, right, draw };
  return oldExp;
}

export function filterSportPreCount(
  betsHistory,
  betType,
  calcOntime,
  calcData
) {
  let left = 0;
  let right = 0;
  let draw = 0;
  let oldExp = {};

  if (betsHistory) {
    // for await (const bet of betList)
    betsHistory.forEach((bet) => {
      if (bet.betType === betType) {
        if (!oldExp[bet.selection]) {
          oldExp[bet.selection] = {};
        }
        const { winnerSelection } = bet;
        console.log(winnerSelection);
        let profileForBet = 0;
        let exposureForBet = 0;
        if (bet.betSide === "back") {
          profileForBet = bet.profit;
          exposureForBet = bet.exposure;
        } else {
          profileForBet = bet.betPlaced;
          exposureForBet = bet.profit;
        }

        console.log("profileForBet :: ", profileForBet);
        console.log("exposureForBet :: ", exposureForBet);
        winnerSelection.forEach((element) => {
          if (element === bet.subSelection) {
            if (!oldExp[bet.selection][element]) {
              oldExp[bet.selection][element] = profileForBet;
            } else {
              oldExp[bet.selection][element] += profileForBet;
            }
          } else {
            if (!oldExp[bet.selection][element]) {
              oldExp[bet.selection][element] = -exposureForBet;
            } else {
              oldExp[bet.selection][element] -= exposureForBet;
            }
          }
        });
      }
    });
  }
  if (calcOntime && calcData && calcData.betType === betType) {
    const { winnerSelection } = calcData;
    console.log(winnerSelection);
    if (!oldExp[calcData.selection]) {
      oldExp[calcData.selection] = {};
    }
    let profileForBet = 0;
    let exposureForBet = 0;
    if (calcData.betSide === "back") {
      profileForBet = calcData.profit;
      exposureForBet = calcData.exposure;
    } else {
      profileForBet = calcData.betPlaced;
      exposureForBet = calcData.profit;
    }

    console.log("profileForBet :: ", profileForBet);
    console.log("exposureForBet :: ", exposureForBet);
    winnerSelection.forEach((element) => {
      if (element === calcData.subSelection) {
        if (!oldExp[calcData.selection][element]) {
          oldExp[calcData.selection][element] = profileForBet;
        } else {
          oldExp[calcData.selection][element] += profileForBet;
        }
      } else {
        if (!oldExp[calcData.selection][element]) {
          oldExp[calcData.selection][element] = -exposureForBet;
        } else {
          oldExp[calcData.selection][element] -= exposureForBet;
        }
      }
    });
  }

  // return { left, right, draw };
  return oldExp;
}

const fancyBetPnl = (bet, run) => {
  const side = (bet.betSide || "").toLowerCase();
  const profit = Number(bet.profit) || 0;
  const exposure = Number(bet.exposure) || 0;
  const stake = Number(bet.betPlaced != null ? bet.betPlaced : bet.stake) || 0;
  if (side === "yes") {
    const line = Number(bet.fancyYes);
    return line <= run ? profit : -exposure;
  }
  if (side === "no") {
    const line = Number(bet.fancyNo);
    return line > run ? stake : -profit;
  }
  return 0;
};

const standForSessionBets = (sessionBets) => {
  const numberArray = {};
  if (!sessionBets || !sessionBets.length) {
    return { numberArray, exposure: 0 };
  }
  const lines = [];
  for (const bet of sessionBets) {
    const line =
      (bet.betSide || "").toLowerCase() === "yes"
        ? Number(bet.fancyYes)
        : Number(bet.fancyNo);
    if (Number.isFinite(line)) {
      lines.push(line - 1, line, line + 1);
    }
  }
  if (!lines.length) {
    return { numberArray, exposure: 0 };
  }
  const minRun = Math.min(...lines);
  const maxRun = Math.max(...lines);
  let rawMin = 0;
  for (let run = minRun; run <= maxRun; run++) {
    let pnl = 0;
    for (const bet of sessionBets) {
      pnl += fancyBetPnl(bet, run);
    }
    pnl = Math.round(pnl * 100) / 100;
    numberArray[run] = pnl;
    if (run === minRun || pnl < rawMin) rawMin = pnl;
  }
  return { numberArray, exposure: rawMin };
};

const bookExposer = (betList) => {
  const groups = {};
  for (const bet of betList || []) {
    if (bet.betType !== "session") continue;
    const selection = bet.selection;
    if (!groups[selection]) groups[selection] = [];
    groups[selection].push(bet);
  }
  return Object.keys(groups).map((selection) => {
    const stand = standForSessionBets(groups[selection]);
    return {
      selection,
      numberArray: stand.numberArray,
      exposure: stand.exposure,
    };
  });
};

export const bookExposerGetPopup = (betList) => {
  const sessionBets = (betList || []).filter((bet) => bet.betType === "session");
  return standForSessionBets(sessionBets).numberArray;
};

/**
 * Fancy Run Position ladder for UI popup only (baazi-style full run range).
 * Rebuilds from all Yes/No bets so hedge order/line mix is correct.
 */
export const getFancyRunPosition = (betList) => {
  const sessionBets = (betList || []).filter(
    (bet) => bet.betType === "session"
  );
  return standForSessionBets(sessionBets).numberArray;
};
